import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './pages/app';
import reportWebVitals from './reportWebVitals';
import ReactGA from 'react-ga';

const trackingId = "UA-167793914-1";
ReactGA.initialize(trackingId);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
